import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { metadataService } from "../../_services";


export class PaymentSchedule extends Component {

    render(){
        return (
            <Table striped>
                <thead>
                    <tr>
                        <th>{metadataService.getLabel('PaymentScheduleAmountDue')}</th>
                        <th>{metadataService.getLabel('PaymentScheduleDateDue')}</th>
                    </tr>
                </thead>
                <tbody>
                {this.props.scheduledPayments.map(function(item) {
                    return (
                        <tr key={item.paymentId}>
                            <td>{metadataService.formatMoney(item.paymentAmount)}</td>
                            <td>{metadataService.formatDateString(item.paymentDate)}</td>
                        </tr>
                    )
                })}
                </tbody>
            </Table>
        )
    }
}

PaymentSchedule.propTypes = {
    scheduledPayments: PropTypes.array.isRequired 
}